import styled, { css } from "styled-components";

export const EmailDetailStyled = styled.div`
  width: 100%;
  position: relative;
  padding: 13px 0 0;
  background: var(--white);
  z-index: 1;

  @media (min-width: 1440px) {
    padding: 20px 0 0;
  }

  .header {
    position: relative;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    color: var(--black);
    gap: 10px;
    padding: 0 15px 10px;

    @media (min-width: 1450px) {
      gap: 24px;
      padding: 0 20px 20px;
    }

    .column {
      width: 100%;
      padding: 12px;
      border-radius: 20px;
      border: 1px solid #e5e5e5;

      @media (min-width: 1440px) {
        padding: 16px;
      }

      .subtitle {
        display: block;
        font-size: 16px;
        line-height: 19px;
        font-weight: 600;
        margin: 0 0 13px;
        text-transform: capitalize;
      }

      .value {
        display: block;
        font-size: 40px;
        line-height: 44px;
        font-weight: 600;
        margin: 0 0 10px;
      }

      &.create-col {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        background: rgba(32, 135, 245, 0.1);

        .text {
          display: block;
          font-size: 14px;
          line-height: 17px;
          font-weight: 600;
          margin: 0 0 14px;
        }

        .btn {
          width: 100%;
          position: relative;
          background: var(--blue);
          padding: 10px 20px;
          border-radius: 50px;
          color: var(--white);
          font-size: 14px;
          line-height: 17px;
          cursor: not-allowed;

          &::before {
            display: none;
          }
        }
      }
    }
  }

  .search-wrap {
    margin: 0 0 20px;

    form {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
    }
  }

  h2 {
    color: #313131;
    font-size: 28px;
    line-height: 32px;
    font-weight: 500;
    margin-bottom: 30px;

    @media (max-width: 1440px) {
      font-size: calc(24px + (28 - 24) * ((100vw - 390px) / (1440 - 390)));
      line-height: calc(28px + (32 - 28) * ((100vw - 390px) / (1440 - 390)));
      margin-bottom: calc(15px + (30 - 15) * ((100vw - 390px) / (1440 - 390)));
    }
  }

  .btn{
          width: 100%;
position: relative;
background: var(--blue);
padding: 10px 20px;
border-radius: 50px;
color: var(--white);
font-size: 14px;
line-height: 17px;
cursor: not-allowed;

&::before{
  display: none;

}
          &:hover {
  
  .content{
  visibility: visible;
  opacity: 1 ;
  transform: translateX(0%) translateY(0px);
  
  }
  }
        }


        .content{
    position: absolute;
    bottom: 45px;
    font-size: 12px;
    line-height: 15px;
    color: var(--white);
    background-color: var(--green);
    padding: 10px;
    border-radius: 4px;
    visibility: hidden;
    opacity: 0;
    transform: translateX(0%) translateY(-50px);
    transition: .5s;
    min-width: 150px;
}

 .content:before{
    content: '';
    position: absolute;
    width: 15px;
    height: 15px;
    background: var(--green);
    bottom:-5px;
    left: 50%;
    transform: rotate(45deg);

}

  
  .filter-wrap {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 10px 15px;
    border-top: 1px solid #e6e7ec;
    
    @media (min-width: 1450px) {
      padding: 20px;

     }
    /* @media (min-width: 1440px) {
      margin-bottom: 15px;
      padding: 0 20px;
    } */

    .input-search {
      color: #1c1c1c;
      &::placeholder {
        color: #1c1c1c;
      }
    }
  }

  .filter-head {
    margin: 0 0 20px;

    @media (min-width: 576px) {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 20px;
    }

    .domain-name-holder {
      display: flex;
      gap: 10px;
      color: #313131;

      .heading {
        display: block;
        font-size: 20px;
        line-height: 24px;
      }
    }

    .form-wrap {
      display: flex;
      align-items: baseline;
      gap: 10px;

      @media (max-width: 575px) {
        margin-bottom: 20px;
      }

      span {
        color: #313131;
      }
    }
  }

  .task-tabs-content {
    width: 100%;
    display: flex;

    .tab-content02,
    .tab-content03 {
      width: 100%;
    }
  }

  .task-tabs-btns {
    width: 100%;
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    gap: 10px;
    font-size: 13px;
    line-height: 16px;
    text-transform: capitalize;

    li {
      margin: 0;
    }

    .btn {
      display: block;
      text-align: center;
      margin: 0;
      outline: none;
      box-shadow: none;
      color: var(--light-gray);
      padding: 12px 15px;
      border-radius: 8px;
      transition: all ease-in-out 0.5s;
      border: 1px solid rgba(157, 157, 157, 0.4);
      background: var(--white);

      &:hover,
      &.active {
        color: var(--white);
        background: var(--primary);
      }
    }
  }

  .name-holder {
    display: flex;
    align-items: center;
    gap: 8px;

    .user-img {
      width: 35px;
      border-radius: 50%;
      overflow: hidden;

      img {
        display: block;
        width: 100%;
        height: auto;
        object-fit: cover;
      }
    }

    .user-name {
      display: block;
      font-weight: 700;
    }
  }
`;

export const EmailTableStyled = styled.div`
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;

  .inner-wrap {
  height: calc(100vh - 302px);
  transition: all 0.350s ease-in-out;
  @media (min-width: 1450px) {
    height: calc(100vh - 373px);
  }
  .trial-banner-visible & {
    height: calc(100vh - 344px);
    @media (min-width: 1450px) {
      height: calc(100vh - 418px);
    }
    }
  }


  .action-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    li {
      margin: 0;
      position: relative;

      button.btn {
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        cursor: pointer;
        padding: 0;
        border-radius: 5px;
        outline: none;
        box-shadow: none;
        background: #f1f1f1;
      }

      img {
        display: block;
        flex-shrink: 0;
        max-width: 100%;
        height: auto;
        width: 16px;
        height: 20px;

        &.menu {
          width: 5px;
        }
      }
    }

    .dropdown-menu {
      position: absolute;
      top: 100%;
      right: 0;
      width: 220px;
      z-index: 5;

      .dropdown-list {
        width: 100%;
        list-style: none;
        margin: 0;
        padding: 10px 0;
        border-radius: 5px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        background: var(--white);

        li {
          margin: 0;
          padding: 0;
          &:hover {
            background: linear-gradient(
              90deg,
              rgba(39, 131, 236, 0.1) 0%,
              rgba(30, 220, 227, 0.1) 100%
            );
          }
        }

        .item-btn {
          display: flex;
          align-items: center;
          gap: 10px;
          width: 100%;
          padding: 5px 15px;
          background: transparent;
          color: var(--primary);
          font-size: 13px;
          line-height: 16px;
          text-align: left;
          cursor: pointer;
        }
      }
    }
  }

  .input-flex {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .warmup-btn-holder {
    display: flex;
    justify-content: center;
    padding: 20px 0 0;
  }

  table {
    th,
    td {
      text-align: center;
    }
  }
`;

export const StyledLinkedinProfiles = styled.div`
  display: flex;
  height: 100%;

  .sidebar {
    width: 100%;
    height: 100%;
    max-width: 230px;
    position: relative;
    @media (min-width: 1450px) {
      max-width: 300px;
    }

    &::after {
      content: "";
      position: absolute;
      top: -20px;
      right: 0;
      bottom: 0;
      width: 1px;
      background: #e6e7ec;
    }
    
    .heading-holder {
      padding: 30px 20px;
      text-align: center;
      border-bottom: 1px solid #e6e7ec;

      @media (min-width: 1450px) {
        padding: 45px 20px;

      }

      .heading {
        display: block;
        font-size: 20px;
        line-height: 24px;
        color: var(--black);
        font-weight: 600;
      }
    }

    .btn-holder {
      padding: 25px 15px;
      border-bottom: 1px solid var(--gray-200);

      .btn-connect {
        font-weight: 500;
        padding: 10px 12px;
        color: #317bff;
        border: 1px solid #317bff;
        background: var(--white);
      }
    }

    .profiles-wrapper {
      .search-holder {
        padding: 20px 12px;

        input {
          height: 35px;
          border-radius: 10px;
        }
      }

      .profiles-holder {
        height: calc(100vh - 228px);
        overflow: auto;
        transition: all 0.350s ease-in-out;
        @media (min-width: 1450px) {
          height: calc(100vh - 268px);
        }
        
        .trial-banner-visible & {
          height: calc(100vh - 270px);
          @media (min-width: 1450px) {
          height: calc(100vh - 310px);
          }
            }
      }
    }
  }

  .content-wrapper {
    flex-grow: 1;
    padding: 15px;
    @media (min-width: 1450px) {
      padding: 20px;
    }

    .heading {
      display: block;
      font-size: 25px;
      line-height: 28px;
      font-weight: 600;
      margin: 0 0 35px;
      color: var(--black);
    }

    .limit-input{
      input{
        max-width: 80px;
        height: 33px;
        padding: 5px 10px;
        text-align: center;
        background: #fcfcfd;
        border: 1px solid var(--gray-250);
        border-radius: 5px;
        margin: 0 auto;
      }
    }

    .delay-select {
      width: 130px;
      margin: 0 auto;
      text-align: start;

      .react-select__control {
        padding-left: 10px;
        padding-right: 10px;
        background: #fcfcfd;
        border-radius: 5px
        ;
      }
      .react-select__dropdown-indicator {
        padding: 3px;
      }
    }
  }

  .profile-detail {
    width: 100%;
    padding: 20px 15px;
    margin: 0 0 40px;
    border: 1px solid #e6e7ec;
    border-radius: 20px;
    @media (min-width: 1450px) {
      padding: 40px 25px;
    }

    .details-holder {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 20px;

      .detail {
        display: flex;
        align-items: center;
        gap: 20px;
        margin: 0 0 30px;
        @media (min-width: 1450px) {
          gap: 35px;
        }

        .img-wrapper {
          position: relative;

          .img-holder {
            width: 60px;
            height: 60px;
            border-radius: 50px;
            overflow: hidden;
            @media (min-width: 1450px) {
              width: 85px;
              height: 85px;
            }

            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .icon-holder {
            position: absolute;
            bottom: 0;
            left: -5px;
            width: 25px;
            height: 25px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #0076b9;
            border: 2px solid var(--white);
            border-radius: 50px;
            overflow: hidden;
          }
        }

        .user-detail {
          .designation {
            display: block;
            font-size: 14px;
            line-height: 18px;
            margin: 0 0 10px;
          }

          .tag-holder {
            width: max-content;
            display: flex;
            align-items: center;
            gap: 12px;
            font-size: 14px;
            line-height: 18px;

            .last-sync {
              b {
                color: var(--black);
              }
            }
          }
        }
      }

      .btn-holder {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 15px;
        width: 100%;
        max-width: 450px;

        .react-select__control {
          min-width: 160px;
          border-radius: 50px;
        }
      }

      button {
        padding: 11px 20px;
      }
    }

    .no-active-profile {
      text-align: center;
    }

    .proxy-holder,
    .proxy {
      width: max-content;
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .proxy-holder {
      padding: 2px 2px 2px 12px;
      border: 1px solid var(--gray-200);
      border-radius: 8px;

      .proxy {
        padding: 6px 10px;
        border: 1px solid var(--gray-200);
        border-radius: 8px;

        .country-flag {
          font-size: 16px;
        }

        .country-name {
          font-weight: 500;
          color: var(--black);
        }

        .ip-address {
          display: block;
          font-size: 14px;
          line-height: 18px;
          color: var(--light-50);
        }
      }
    }
  }
`;
export const StyledProfile = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px;
  cursor: pointer;
  
  @media (min-width: 1450px) {
    padding: 16px 12px;
  }
  
  .img-wrapper {
    position: relative;
    .img-holder {
      width: 40px;
      height: 40px;
      border-radius: 50px;
      overflow: hidden;

      @media (min-width: 1450px) {
        width: 50px;
        height: 50px;
        
      }

      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .icon-holder {
      position: absolute;
      bottom: 0;
      right: -5px;
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #0076b9;
      border: 2px solid var(--white);
      border-radius: 50px;
      overflow: hidden;

      @media (min-width: 1450px) {
        width: 25px;
        height: 25px;
      }
      
      svg{
        @media (max-width: 1449px) {
          width: 12px;
          height: 12px;
      }
    }
  }
}

  .user-name {
    width: 183px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: var(--dark);
    font-weight: 500;
  }

  ${({ $isActive }) =>
    $isActive &&
    css`
      background: var(--primary-100);
    `}

  .online-status-dot {
    width: 10px;
    height: 10px;
    flex-shrink: 0;
    background: ${({ $isOnline }) =>
    $isOnline ? "var(--green)" : "var(--danger)"};
    border-radius: 50px;
  }
`;

export const StyledUserNameHolder = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 15px;

  .user-name {
    display: block;
    font-size: 24px;
    line-height: 28px;
    color: var(--black);
  }

  .online-status-dot {
    width: 10px;
    height: 10px;
    flex-shrink: 0;
    background: ${({ $isOnline }) =>
    $isOnline ? "var(--green)" : "var(--danger)"};
    border-radius: 50px;
  }
`;

export const StyledTag = styled.div`
  font-weight: 500;
  color: ${({ $isConnected }) =>
    $isConnected ? "var(--blue)" : "var(--danger)"};
  background: ${({ $isConnected }) =>
    $isConnected ? "var(--primary-100)" : "rgba(194, 6, 6, 0.1)"};
  padding: 5px 20px;
  border-radius: 50px;
`;

export const EnrichModal = styled.div`
  position: relative;

  .enrich-holder {
    text-align: center;

    .img-holder {
      margin: 0 0 30px;
    }

    .heading {
      display: block;
      font-size: 25px;
      line-height: 28px;
      font-weight: 500;
      color: var(--text-color-50);
      margin: 0 0 10px;
    }

    .text {
      display: block;
      margin: 0 0 35px;
    }

    .btn-holder {
      display: flex;
      gap: 15px;

      button {
        border-radius: 10px;
      }
    }
  }
`;
export const StyledConnectLinkedinAccount = styled.div``;
export const LinkedinTableWrap = styled.div`
  position: relative;

  .rate-limits-save {
    display: flex;
    justify-content: flex-end;
    padding: 10px 70px 0 0;

    @media (min-width: 1450px) {
      padding: 16px 0 0;
    }
    
    .trial-banner-visible & {
      padding: 10px 70px 0 0;
      @media (min-width: 1450px) {
        padding: 22px 70px 0 0;
      }
    }
  }

  .table-footer {
    display: none;
  }

  .inner-wrap{
    height: calc(100vh - 420px);
    transition: all 0.350s ease-in-out;
    @media (min-width: 1450px) {
      height: calc(100vh - 550px);
    }
    
    .trial-banner-visible & {
      height: calc(100dvh - 460px);
      @media (min-width: 1450px) {
        height: calc(100dvh - 550px);
      }
    }
  }

  table {
    border-collapse: separate;
    border-spacing: 0;

    thead {
      .table-head {
        border-width: 0;

        th {
          &:first-child {
            padding-left: 25px;
          }
          &:last-child {
            text-align: center;
            padding-right: 30px;
          }
        }
      }
      .separator {
        th {
          padding: 6px 8px;
          border: none;
        }
      }
      th {
        padding: 13px 8px;
        border-width: 1px 0;
        border-style: solid;
        border-color: #e6e7ec;
        text-align: center;

        &:first-child {
          border-width: 1px 0 1px 1px;
          border-top-left-radius: 50px;
          border-bottom-left-radius: 50px;
        }
        &:last-child {
          border-width: 1px 1px 1px 0;
          border-top-right-radius: 50px;
          border-bottom-right-radius: 50px;
        }
      }
    }
    tbody {
      tr:first-child td:first-child {
        border-top-left-radius: 20px;
        border-width: 1px 0 0 1px;
      }
      tr:first-child td:last-child {
        border-top-right-radius: 20px;
        border-width: 1px 1px 0 0;
      }

      tr:last-child td:first-child {
        border-bottom-left-radius: 20px;
        border-width: 1px 0 1px 1px;
      }
      tr:last-child {
        td {
          border-width: 1px 0 1px;
        }

        td:last-child {
          border-bottom-right-radius: 20px;
          border-width: 1px 1px 1px 0;
        }
      }

      tr {
        td {
          padding: 17px 8px;
          border-width: 1px 0 0 0;
          border-style: solid;
          border-color: #e6e7ec;
          text-align: center;

          &:first-child {
            padding-left: 20px;
            border-width: 1px 0 0 1px;
          }

          &:last-child {
            padding-right: 25px;
            border-width: 1px 1px 0 0;
          }
        }
      }
    }

    .react-select__control {
      height: 33px;
    }
  }
`;
